import { render, staticRenderFns } from "./LoadPlaceholder.vue?vue&type=template&id=3f41ecb2&scoped=true"
import script from "./LoadPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LoadPlaceholder.vue?vue&type=style&index=0&id=3f41ecb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f41ecb2",
  null
  
)

export default component.exports